/** نمایشِ یک راهنما: خلاصه، تصویر(ها)، مراحل، فیلدها، سؤالاتِ پرتکرار، نکته‌ها (v2.146.0). */
import React from "react";
import { Alert, Collapse, Image, Space, Steps, Table, Tag, Typography } from "antd";
import { BulbOutlined, QuestionCircleOutlined } from "@ant-design/icons";

const { Title, Paragraph, Text } = Typography;
export const guideImg = (name) => `${process.env.PUBLIC_URL || ""}/guide-img/${name}.jpg`;

export default function GuideView({ guide, compact = false }) {
  if (!guide) return null;
  const g = guide;
  return (
    <div style={{ lineHeight: 1.9 }}>
      {!compact && <Title level={4} style={{ marginTop: 0 }}>{g.title}</Title>}
      <Paragraph style={{ fontSize: 14 }}>{g.summary}</Paragraph>

      {g.imgs?.length > 0 && (
        <Image.PreviewGroup>
          <Space wrap size={10} style={{ marginBottom: 12 }}>
            {g.imgs.map((n) => (
              <Image key={n} src={guideImg(n)} alt={g.title} width={compact ? 300 : 420}
                style={{ borderRadius: 8, border: "1px solid var(--border, #e4e8f0)" }}
                placeholder={<div style={{ width: compact ? 300 : 420, height: 200, background: "#f3f4f6" }} />} />
            ))}
          </Space>
          <div><Text type="secondary" style={{ fontSize: 12 }}>برای بزرگ‌کردن روی تصویر بزنید (داده‌ها عمداً تار شده‌اند).</Text></div>
        </Image.PreviewGroup>
      )}

      {g.steps?.length > 0 && (
        <>
          <Title level={5} style={{ marginTop: 16 }}>مراحلِ کار</Title>
          <Steps direction="vertical" size="small" current={-1}
            items={g.steps.map((s, i) => ({ title: <span style={{ whiteSpace: "normal", fontWeight: 400 }}>{s}</span>, status: "process", icon: <Tag color="blue" style={{ margin: 0, borderRadius: 12 }}>{(i + 1).toLocaleString("fa-IR")}</Tag> }))} />
        </>
      )}

      {g.fields?.length > 0 && (
        <>
          <Title level={5} style={{ marginTop: 16 }}>فیلدها و اصطلاحات</Title>
          <Table size="small" pagination={false} rowKey={(r) => r[0]} dataSource={g.fields} showHeader={false}
            columns={[
              { dataIndex: 0, width: 170, render: (v) => <b>{v}</b> },
              { dataIndex: 1, render: (v) => <span style={{ whiteSpace: "normal" }}>{v}</span> },
            ]} />
        </>
      )}

      {g.faq?.length > 0 && (
        <>
          <Title level={5} style={{ marginTop: 16 }}><QuestionCircleOutlined /> سؤالاتِ پرتکرار</Title>
          <Collapse size="small" items={g.faq.map(([q, a], i) => ({ key: String(i), label: q, children: <Paragraph style={{ margin: 0 }}>{a}</Paragraph> }))} />
        </>
      )}

      {g.tips?.length > 0 && (
        <Alert type="info" showIcon icon={<BulbOutlined />} style={{ marginTop: 16 }} message="نکته"
          description={<ul style={{ margin: 0, paddingInlineStart: 18 }}>{g.tips.map((t) => <li key={t}>{t}</li>)}</ul>} />
      )}
    </div>
  );
}
